import { createQueryKeys } from '@lukemorales/query-key-factory';
import { queryReceptionBuyerStat } from 'services/api/conversation.convList';
import { getBootProcessing } from 'views/BootGuide/service';

export const bootstraps = createQueryKeys('bootstraps', {
  inprogress: (aiEnable?: boolean) => ({
    queryKey: [aiEnable],
    queryFn: ({ signal }) => getBootProcessing(aiEnable, signal),
  }),
  receptionStat: (timeZone: number) => ({
    queryKey: [timeZone],
    queryFn: ({ signal }) => queryReceptionBuyerStat({ timeZone }, signal),
  }),
});
